// Function to toggle each innversubmenu accordion-style
function toggleSubmenu(event) {
  event.preventDefault();
  const parentLi = event.target.closest("li");
  const innversubmenu = parentLi.querySelector(".innversubmenu");

  if (innversubmenu.style.maxHeight) {
    // Collapse the innversubmenu
    innversubmenu.style.maxHeight = null;
    parentLi.classList.remove("open");
    parentLi.querySelector(".icon").textContent = "+";
  } else {
    // Expand the innversubmenu
    innversubmenu.style.maxHeight = innversubmenu.scrollHeight + "px";
    parentLi.classList.add("open");
    parentLi.querySelector(".icon").textContent = "-";
  }
}
